
import { supabase } from '@/integrations/supabase/client';
import { MultiplayerRoom, MultiplayerQuizData, MultiplayerParticipant } from '@/types/multiplayer-room';

export const fetchActiveRooms = async (): Promise<MultiplayerRoom[]> => {
  const oneHourAgo = new Date();
  oneHourAgo.setHours(oneHourAgo.getHours() - 1);

  const { data, error } = await supabase
    .from('multiplayer_rooms')
    .select('*')
    .or(`status.eq.waiting,and(status.eq.in_progress,started_at.gt.${oneHourAgo.toISOString()})`)
    .order('created_at', { ascending: false });
  
  if (error) throw error;

  // Fetch participants for rooms
  const roomIds = (data || []).map(r => r.id);
  const { data: participants } = roomIds.length > 0
    ? await supabase.from('multiplayer_participants').select('*').in('room_id', roomIds)
    : { data: [] };

  // Fetch profiles
  const userIds = [...new Set((participants || []).map(p => p.user_id))];
  const { data: profiles } = userIds.length > 0
    ? await supabase.from('profiles').select('id, display_name').in('id', userIds)
    : { data: [] };

  const profileMap = new Map((profiles || []).map(p => [p.id, p]));

  const activeRooms = (data || []).filter(room => 
    (participants || []).some(p => p.room_id === room.id)
  );
  
  return activeRooms.map(room => ({
    id: room.id,
    status: room.status,
    created_at: room.created_at,
    started_at: room.started_at,
    completed_at: room.completed_at,
    current_question_index: room.current_question_index,
    quiz_title: room.quiz_title || undefined,
    quiz_data: typeof room.quiz_data === 'string' ? JSON.parse(room.quiz_data) : room.quiz_data,
    multiplayer_participants: (participants || [])
      .filter(p => p.room_id === room.id)
      .map(p => ({
        id: p.id,
        user_id: p.user_id,
        is_ready: p.is_ready,
        score: p.score,
        profiles: {
          display_name: profileMap.get(p.user_id)?.display_name || 'Unknown'
        }
      })) as MultiplayerParticipant[]
  }));
};
